import { NgClass } from '@angular/common';
import { TextFieldModule } from '@angular/cdk/text-field';
import { ReactiveFormsModule } from '@angular/forms';
import { booleanAttribute, Component, ElementRef, input, OnDestroy, OnInit, ViewChild } from '@angular/core';

import { AppMaterialModule } from '../../../material.module';
import { AttributeDirective } from 'src/app/infrastructure/directives/attribute.directive';
import { _MatFormFieldComponent } from '../../components/_mat-form-field.component';

@Component({
    selector: 'app-textarea-control',
    templateUrl: './textarea-control.component.html',
    styleUrls: [
        './textarea-control.component.scss',
        '../../control.scss',
    ],
    standalone: true,
    host: {
        '[class.readonly]': 'readonly$$()'
    },
    imports: [
        AppMaterialModule,
        AttributeDirective,
        NgClass,
        ReactiveFormsModule,
        TextFieldModule,
    ],
})
export class TextareaControlComponent
    extends _MatFormFieldComponent
    implements OnInit, OnDestroy
{
    override attributes$$        = this._input_attributes$$;
    override autofocus$$         = this._input_autofocus$$;
    override control$$           = this._control$$;
    override controlName$$       = this._input_controlName$$;
    override disabled$$          = this._input_disabled$$;
    override errorShow$$         = this._input_errorShow$$;
    override errorStateMatcher$$ = this._input_errorStateMatcher$$;
    override id$$                = this._input_id$$;
    override lockOnLoad$$        = this._input_lockOnLoad$$;
    override placeholder$$       = this._input_placeholder$$;
    override readonly$$          = this._input_readonly$$;
    override subscriptHide$$     = this._input_subscriptHide$$;
    override tabIndex$$          = this._tabIndex$$;
    override value$$             = this._input_value$$;
    override valueReset$$        = this._input_valueReset$$;

    // mat-form-field:
    override appearance$$         = this._input_appearance$$;
    override classHeight$$        = this._input_classHeight$$;
    override color$$              = this._input_color$$;
    override floatLabel$$         = this._input_floatLabel$$;
    override hideLineRipple$$     = this._input_hideLineRipple$$;
    override hideRequiredMarker$$ = this._hideRequiredMarker$$;
    override hint$$               = this._input_hint$$;
    override hintAlign$$          = this._input_hintAlign$$;
    override hintLabel$$          = this._input_hintLabel$$;
    override label$$              = this._input_label$$;
    override required$$           = this._input_required$$;
    override subscriptSizing$$    = this._input_subscriptSizing$$;

    // textarea:
    // autosize aan = hoogte groeit met de inhoud (min/maxRows begrenzen); maxRows 0 = geen limiet.
    // rows is de begin-/vaste hoogte wanneer autosize uit staat.
    input_autosize$$           = input(true,                            { transform: booleanAttribute, alias: 'autosize' });
    input_maxRows$$            = input<number>(0,                       { alias: 'maxRows' });
    input_minRows$$            = input<number>(2,                       { alias: 'minRows' });
    input_rows$$               = input<number>(3,                       { alias: 'rows' });

    @ViewChild('inputField', { read: ElementRef }) inputField?: ElementRef<HTMLTextAreaElement> | null;

    override ngOnInit(): void {
        super._ngOnInit();

        const _value = this._input_value$$();
        if (_value) { this.control$$().setValue(_value); }
    }

    override errorMessage_getFirst(): string {
        return this._validationMessage(this.control$$()?.errors);
    }

    override ngOnDestroy(): void {
        super._ngOnDestroy();
    }
}
